// The scene's three axes by name, and the step from a name to the component
// index that Vector3 and Box3 take. A leaf, so snapping, movement and the
// wall helpers can all share it.
import * as THREE from 'three';

export type Axis = 'x' | 'y' | 'z';

export const AXES: readonly Axis[] = ['x', 'y', 'z'];

/**
 * @param {Axis} axis An axis.
 * @return {number} Its component index, so one function serves every axis.
 */
export const axisIndex = (axis: Axis): number =>
    axis === 'x' ? 0 : axis === 'y' ? 1 : 2;

/**
 * @param {Axis} axis An axis.
 * @param {number} [length] How long.
 * @return {THREE.Vector3} A vector that long along it.
 */
export const axisVector = (axis: Axis, length = 1): THREE.Vector3 =>
    new THREE.Vector3().setComponent(axisIndex(axis), length);
